import React from 'react';
import Parser from 'react-html-parser';
import Grow from '@material-ui/core/Grow';
import VerticalAlignTopRounded from '@material-ui/icons/VerticalAlignTopRounded';

import styles from './styles';
import classes from './classes.module.css';
import Footer from '../../../../ui-components/Footer';
import Component from '../../../../ui-components/Component';
import { isEmptyList, isEmptyString, path } from '../../../../utils';
import { withResizer, withTranslations } from '../../../../HoCs';
import LandingImages from '../../../LandingPageNew/LandingImages';
import { guc } from '../../../../services/Localisation';
import { getImage } from '../../../../resources/images';
import view from '../../../../Enums';
import IconButton from '../../../../ui-components/Button/Icon';

class MainBody extends Component {

    styles = styles;
    containerRef = React.createRef();
    counter = 1;

    state = {
        scrollPos: 0,
    };

    gi = key => {
        const image = path(LandingImages[key], this.getViewMode());
        return !isEmptyString(image) ? getImage(guc(image)) : null;
    }

    renderNumber = c_i => c_i == 0 ? '' : <>{this.counter++}.&nbsp;&nbsp;</>;

    renderContent = ({ content_heading, type_content, content }, c_i, s_i) => <div key={`${s_i}_${c_i}`} id={`section_${s_i}_content_${c_i}`}
        style={this.gs('content')} className={classes.content}>
        {this.props.isValidContentHeading(s_i, c_i) && <div style={this.gs('content_heading')}>{this.renderNumber(c_i)}{Parser(content_heading)}</div>}
        {!isEmptyString(content) && <div style={this.gs('content_content')}>{type_content === 'HTML' ? Parser(content) : <img width='100%' src={this.gi(content)} />}</div>}
    </div>;

    renderSection = ({ sub_heading, contents_points: contents }, s_i) => <div key={s_i} id={`section_${s_i}`} style={this.gs('section')}>
        {!isEmptyString(sub_heading) && <div style={this.gs('section_heading')}>
            {Parser(sub_heading)}
            <div style={this.gs('underline')} />
        </div>}
        {!isEmptyList(contents) && contents.map((content, c_i) => this.renderContent(content, c_i, s_i))}
    </div>;

    renderGoToTopButton = () => <Grow in={this.state.scrollPos > 500}>
        <IconButton rippleColor='white' style={this.gs('go_to_top')} onClick={this.scrollToTop}>
            <VerticalAlignTopRounded style={{ fontSize: 18 }} />
            <span style={this.gs('go_to_top_text')}>Back to top</span>
        </IconButton>
    </Grow>;

    render = () => {
        const { section_details: sections } = this.props.data;
        this.counter = 1;

        return <div style={this.gs('container')} ref={this.containerRef} onScroll={this.onContainerScroll}>
            {!isEmptyList(sections) && sections.map(this.renderSection)}
            <div style={{ height: 100 }} />
            {this.renderGoToTopButton()}
            <Footer viewMode={this.getViewMode()} />
        </div>;
    }

    // called through ref
    scrollTo = (s_i, c_i) => {
        const element = document.getElementById(`section_${s_i}` + (c_i != undefined ? `_content_${c_i}` : ''));
        const offset = { [view.DESKTOP]: 35, [view.TAB]: 8, [view.MOBILE]: 16 }
        element != null && this.containerRef.current.scrollTo(0, element.offsetTop - offset[this.getViewMode()]);
    }

    onContainerScroll = e => this.setState({ scrollPos: e.currentTarget.scrollTop });

    scrollToTop = () => this.containerRef.current.scrollTo(0, 0);

}

export default withTranslations(withResizer(MainBody));